$ = require 'jquery'
Auth = require 'app/scripts/db/auth'
ApiError = require 'app/scripts/network/api-error'
AutoInsertionView = require 'app/scripts/views/internal/autocomplete/auto-insertion-view'
AutoMentionerView = require 'app/scripts/views/internal/autocomplete/auto-mentioner-view'
BoardListAnnouncementComponent = require 'app/scripts/views/board-list/board-list-announcement-component'
BoardListItemAddComponent = require 'app/scripts/views/board-list/board-list-item-add-component'
BoardListItemPrivateBoardComponent = require 'app/scripts/views/board-list/board-list-item-private-board-component'
BoardListItemComponent = require 'app/scripts/views/board-list/board-list-item-component'
BoardListItemDndComponent = require 'app/scripts/views/board-list/board-list-item-dnd-component'
BoardListSectionComponent = require 'app/scripts/views/board-list/board-list-section-component'
BoardListSectionDndComponent = require 'app/scripts/views/board-list/board-list-section-dnd-component'
BoardListSectionHeaderComponent = require 'app/scripts/views/board-list/board-list-section-header-component'
BoardListSectionHeaderLinkComponent = require 'app/scripts/views/board-list/board-list-section-header-link-component'
BoardsPageAnnouncement = require 'app/scripts/data/boards-page-announcement'
CompleterUtil = require 'app/scripts/views/internal/autocomplete/completer-util'
Controller = require 'app/scripts/controller'
CreateBoardComponent = require 'app/scripts/views/board-create/create-board-component'
Dates = require 'app/scripts/lib/dates'
Dialog = require 'app/scripts/views/lib/dialog'
{ dontUpsell } = require '@trello/config'
EmojiCompleterView = require 'app/scripts/views/internal/autocomplete/emoji-completer-view'
{ featureFlagClient } = require '@trello/feature-flag-client'
GoldBannerView = require 'app/scripts/views/member/gold-banner-view'
HomeContainer = require 'app/scripts/views/home/home-container'
{ IconName } = require 'app/common/components/controls'
Language = require '@trello/locale'
ModelCache = require 'app/scripts/db/model-cache'
Payloads = require 'app/scripts/network/payloads'
PopOver = require 'app/scripts/views/lib/pop-over'
Promise = require 'bluebird'
React = require 'react'
ReactDOM = require '@trello/react-dom-wrapper'
{ ReactRootComponent } = require 'app/scripts/views/internal/react-root-component'
RecentBoards = require 'app/scripts/lib/recent-boards'
recentBoardsHelper = new RecentBoards()
{ Storage } = require '@trello/storage'
TeamBannerView = require 'app/scripts/views/member/team-banner-view'
TeamBoardsLinkBanner = require('app/scripts/views/board-list/board-list-team-board-link-component').default
{ UpgradePromptButtonConnected: UpgradePromptButton } = require 'app/src/components/UpgradePrompts/UpgradePromptButton'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
createBoardHelpers = require 'app/scripts/views/board-create/helpers'
f = require 'effing'
getGoldBanner = require 'app/scripts/lib/util/get-gold-banner'
getTeamBanner = require 'app/scripts/lib/util/get-team-banner'
l = require 'app/scripts/lib/localize'
{ mixin } = require 'app/scripts/lib/mixin_DO_NOT_USE'
ninvoke = require 'app/scripts/lib/util/ninvoke'
recup = require 'recup'
SidebarState = require 'app/scripts/view-models/sidebar-state'
templates = require 'app/scripts/views/internal/templates'
{ track, trackUe } = require '@trello/analytics'
{ maybeDisplayMemberLimitsError } = require 'app/scripts/views/board-menu/member-limits-error'
isDesktop = require('@trello/browser').isDesktop()
{ TemplatesInAppGallery } = require  'app/src/components/Templates/TemplatesInAppGallery'

module.exports = mixin AutoInsertionView, CompleterUtil, class MemberHomeView extends View

  events: Util.extendEvents
    'keyup .js-text': 'keyAutoMention'
    'keydown .js-text': 'keydownJsText'

  initialize: ->
    renderReactSectionDebounced = @frameDebounce @renderReactSection

    @listenTo @model.organizationList, 'add remove reset change:memberships',
      @frameDebounce @renderBanner

    @listenTo @model.organizationList, 'add remove reset change:name change:displayName change:logoHash change:products change:limits',
      renderReactSectionDebounced

    @listenTo @model.boardList,
      'add remove reset change:name change:idOrganization change:dateLastActivity change:dateLastView change:closed change:prefs.isTemplate',
      renderReactSectionDebounced

    @listenTo @model.boardStarList, 'add remove reset change:pos',
      @renderReactSection

    @listenTo @model, 'change:oneTimeMessagesDismissed', @renderReactSection
    @listenTo @model, 'change:oneTimeMessagesDismissed', @renderBanner

    @templateFlagEnabled = featureFlagClient.get('publicproduct.templates_v1', false)
    featureFlagClient.on 'publicproduct.templates_v1', (newVal) =>
      @templateFlagEnabled = newVal
      renderReactSectionDebounced()

  className: 'member-boards-view'

  keydownJsText: (e) ->
    if (PopOver.view instanceof EmojiCompleterView) || (PopOver.view instanceof AutoMentionerView)
      @checkInsert?(e)

  focusedCard: null

  getCard: ->
    return @focusedCard

  setFocusedCard: (idCard) =>
    @focusedCard = idCard

  getTextInput: ->
    @$('.js-text:focus')

  getEmojiTarget: ->
    @$('.js-text:focus')

  getMentionTarget: ->
    @$('.js-text:focus')[0]

  getReactRoot: ->
    React.createElement ReactRootComponent, {},
      @showHomeContainer()

  renderReactSection: ->
    ReactDOM.render(@getReactRoot(), @$reactRoot[0])

    @

  renderBanner: ->
    $banners = @$('.js-boards-page-banners').empty()

    {
      bannerToDisplay
      idBannersToDismiss
    } = getTeamBanner(@model)

    goldBanner = getGoldBanner(@model)

    if bannerToDisplay
      if goldBanner && !bannerToDisplay.doesIncludeGold
        $banners.prepend(@subview(GoldBannerView, @model, { banner: goldBanner, idTeamBannersToDismiss: idBannersToDismiss }).render().el)
      else
        $banners.prepend(new TeamBannerView({ bannerToDisplay, idBannersToDismiss, @model }).render().el)
        track('Boards Page', 'Team Banner Displayed', bannerToDisplay.type)
        trackUe('Boards Page', 'display', 'team banner', '', 'to a user',  '', bannerToDisplay.type)
    else if goldBanner
      $banners.prepend(@subview(GoldBannerView, @model, { banner: goldBanner }).render().el)

  getPrivateBoardTiles: (org) ->
    if !org?.isPremium() && !isDesktop
      _.range(org.getPrivateBoardCount()).map((i) =>
        React.createElement(
          BoardListItemPrivateBoardComponent,
          key: i,
          org: org
        )
      )

  render: ->
    @$el.html('<div class="js-boards-page-banners"></div><div class="js-boards-page"></div>')
    @$reactRoot ?= @$('.js-boards-page')
    @orgname = @options.orgname
    @showHomeBoardsTab = @options.showHomeBoardsTab
    @templatesData = @options.templatesData

    @renderReactSection()
    @renderBanner()

    @

  showAllBoards: ->
    trackObjStarred =
      prepObj: 'on boards tab'
      indObj: ''
      method: 'by clicking starred board tile'
    props =
      items: @getStarredBoards().map((board) =>
        @boardToBoardItemDndElement(board, 'Starred Boards', trackObjStarred))
      header: @getStarredBoardsHeader()
      noSidebarMod: true
    if props.items.length > 0
      recup.createElement BoardListSectionDndComponent, props

    trackObjRecent =
      prepObj: 'on boards tab'
      indObj: ''
      method: 'by clicking recent board tile'
    props =
      items: @getRecentBoards().map((board) =>
        @boardToBoardItemElement(board, 'Recent Boards', trackObjRecent))
      header: @getRecentBoardsHeader()
      noSidebarMod: true
    if props.items.length > 0
      recup.createElement BoardListSectionDndComponent, props

    trackObjPersonal =
      prepObj: 'on boards tab'
      indObj: ''
      method: 'by clicking personal board tile'
    props =
      items: @getMyBoards().map((board) =>
        @boardToBoardItemElement(board, 'Personal Boards', trackObjPersonal))
      header: @getMyBoardsHeader()
      mayBeSorted: true
      noSidebarMod: true
      canShowWelcomePopover: false
      createNewItem: Auth.me().canCreateBoardIn(org) && React.createElement BoardListItemAddComponent,
        preloadData: f(@, 'preloadCreateBoardData')
        newBoard: f(@, 'newBoard', @model)

    recup.createElement BoardListSectionComponent, props

    trackObjTeam =
      prepObj: 'on boards tab'
      indObj: ''
      method: 'by clicking team board tile'
    for org in @model.getSortedOrgs()
      props =
        items: @getOrgBoards(org).map((board) =>
          @boardToBoardItemElement(board, 'Team Boards', trackObjTeam))
        header: @getOrgHeader(org)
        mayBeSorted: true
        noSidebarMod: true
        topBanner: if @getOrgBoards(org).length == 0 then @getTeamBoardLinkBanner(org, true)
        bottomBanner: if @getOrgBoards(org).length != 0 && @model.organizationList.length == 1 then @getTeamBoardLinkBanner(org, false)
        createNewItem: Auth.me().canCreateBoardIn(org) && React.createElement BoardListItemAddComponent,
          preloadData: f(@, 'preloadCreateBoardData')
          newBoard: f(@, 'newBoard', org)
          org: org
          ctaTrackEvent: -> trackUe(
            'home',
            'opens',
            'team page bc tab',
            '',
            '',
            'by clicking full upgrade prompt in home page board list',
          )
        orgId: org.id
        orgName: org.get('name')
      recup.createElement BoardListSectionComponent, props

  showTeamBoards: ->
    org = ModelCache.findOne('Organization', 'name', @orgname)

    trackObjStarred =
      prepObj: 'on team tab'
      indObj: ''
      method: 'by clicking starred board tile'
    props =
      items: @getStarredOrgBoards(org).map((board) =>
        @boardToBoardItemElement(board, 'Starred Boards', trackObjStarred))
      header: @getStarredTeamBoardsHeader()
      noSidebarMod: true
    if props.items.length > 0
      recup.createElement BoardListSectionComponent, props

    trackObjMember =
      prepObj: 'on team tab'
      indObj: 'they are a member of'
      method: 'by clicking team board tile'
    props =
      items: @getOrgBoards(org).map((board) =>
        @boardToBoardItemElement(board, 'Team Boards', trackObjMember))
      header: @getUserTeamBoardsHeader()
      noSidebarMod: true
      createNewItem:  Auth.me().canCreateBoardIn(org) && React.createElement BoardListItemAddComponent,
        preloadData: f(@, 'preloadCreateBoardData')
        newBoard: f(@, 'newBoard', org)
        org: org
        ctaTrackEvent: -> trackUe(
          'home',
          'opens',
          'team page bc tab',
          '',
          '',
          'by clicking full upgrade prompt in home page team board list',
        )
      orgId: org.id
      orgName: org.get('name')
    recup.createElement BoardListSectionComponent, props

    trackObjNonMember =
      prepObj: 'on team tab'
      indObj: 'they are not a member of'
      method: 'by clicking team board tile'
    props =
      items: @getNonMemberOrgBoards(org).map((board) =>
        @boardToBoardItemElement(board, 'Team Boards', trackObjNonMember))
      header: @getTeamBoardsHeader()
      noSidebarMod: true
      createNewItem: Auth.me().canCreateBoardIn(org) && React.createElement BoardListItemAddComponent,
        preloadData: f(@, 'preloadCreateBoardData')
        newBoard: f(@, 'newBoard', org)
        org: org
      orgId: org.id
      orgName: org.get('name')
      privateBoardTiles: @getPrivateBoardTiles(org)
    if props.items.length > 0
      recup.createElement BoardListSectionComponent, props

  showTemplatesTab: (templatesGalleryProps) ->
    recup.createElement TemplatesInAppGallery, templatesGalleryProps

  showHomeContainer: ->
    # TODO: When we add the sidebar with Homecoming, we should get rid
    # noSidebarMod (see also
    # views/board-list/board-list-section-component.coffee and
    # boards-page-board-section.less).

    recup.render => recup.div =>
      showAnnouncement =
        BoardsPageAnnouncement?.enabled &&
        !@model.isDismissed(BoardsPageAnnouncement.id) &&
        Language.matches(Language.currentLocale, BoardsPageAnnouncement.locale) &&
        Date.now() < Dates.parse(BoardsPageAnnouncement.dateExpires)

      if showAnnouncement
        if !@_recordedDisplayed
          @_recordedDisplayed = true
          track("Boards Page Announcement", "Displayed", BoardsPageAnnouncement.id)
        recup.createElement BoardListAnnouncementComponent, {
          icon: BoardsPageAnnouncement.icon
          message: BoardsPageAnnouncement.message
          onClick: (e) =>
            if e.target.href?
              track("Boards Page Announcement", "Click", BoardsPageAnnouncement.id, e.target.href)
          onDismiss: (message) =>
            @model.dismiss(BoardsPageAnnouncement.id)
            track("Boards Page Announcement", "Dismiss", BoardsPageAnnouncement.id)
        }

      recup.createElement HomeContainer, {
        modelCache: @modelCache
        model: @model
        orgname: @orgname
        allBoards: !@orgname && !@templatesData && @showHomeBoardsTab && @showAllBoards.bind(@)
        orgBoards: @orgname && @showHomeBoardsTab && @showTeamBoards.bind(@)
        templates: !@orgname && !@showHomeBoardsTab && @templatesData && @showTemplatesTab.bind(@, @templatesData)
        templateCategory: @templatesData && @templatesData.category
        setFocusedCard: @setFocusedCard
      }

  backgroundObjForBoard: (board) ->
    _.extend brightness: board.getPref('backgroundBrightness'),
      if board.getPref('backgroundTile')
        image: board.getPref('backgroundImage')
        tiled: true
      else if preview = Util.smallestPreviewBiggerThan(board.getPref('backgroundImageScaled'), 400, 200)?.url ? board.getPref('backgroundImage')
        image: preview
        tiled: false
      else
        color: board.getPref('backgroundColor') ? board.getClientBackgroundColor('blue')

  boardToBoardItemDndElement: (board, sectionName, trackObj) ->
    props = @boardToBoardItemProps(board, sectionName, trackObj)
    props.onDragHover = (idBoardHoverer) =>
      boardStarList = Auth.me().boardStarList
      boardStar = boardStarList.getBoardStar(idBoardHoverer)
      index = boardStarList.getBoardIndex(board.id)
      pos = boardStarList.getNewPos(boardStar, index)
      boardStar.set({ pos })
    props.onDragEnd = ->
      boardStarList = Auth.me().boardStarList
      boardStar = boardStarList.getBoardStar(board.id)
      Promise.using ModelCache.getLock(), ->
        ninvoke boardStar, 'update', (pos: boardStar.get('pos'))
        .catch ->
      .done()
      return
    props.orgname = board.getOrganization()?.get('displayName')
    props.isDraggable = true

    React.createElement BoardListItemDndComponent, props

  boardToBoardItemElement: (board, sectionName, trackObj) ->
    React.createElement BoardListItemComponent,
      @boardToBoardItemProps(board, sectionName, trackObj)

  boardToBoardItemProps: (board, sectionName, trackObj) ->
    id: board.id
    name: board.get('name')
    hasUnseenActivity: board.hasUnseenActivity()
    dateLastActivity: new Date(board.get('dateLastActivity') ? Util.idToDate(board.id))
    isLessActive: board.isLessActive()
    background: @backgroundObjForBoard(board)
    showOptions: Auth.isLoggedIn()
    isStarred: Auth.me().boardStarList.getBoardStar(board.id)?
    relUrl: board.getUrl()
    onStarClick: (idBoard) =>
      boardStarList = Auth.me().boardStarList
      Promise.using ModelCache.getLock(), ->
        if !boardStarList.getBoardStar(idBoard)?
          boardStarList.starBoard(idBoard)
          track('Boards View', 'Star Board', sectionName)
        else
          boardStarList.unstarBoard(idBoard)
          track('Boards View', 'Unstar Board', sectionName)
      .done()
      return
    isTemplate: @templateFlagEnabled && board.isTemplate()
    badgeComponents: []
    tagComponents: []
    key: board.id
    onBoardClick: ->
      category = 'home'
      verb = 'opens'
      dirObj = 'board'
      prepObj = trackObj.prepObj
      indObj = trackObj.indObj
      method = trackObj.method
      orgId = board.getOrganization()?.get('id')
      context =
        boardId: board.id
        teamId: orgId
      trackUe(category, verb, dirObj, prepObj, indObj, method, context)

  preloadCreateBoardData: ->
    createBoardHelpers.preloadData()

  newBoard: (model, el) ->
    if maybeDisplayMemberLimitsError($(el), null, Auth.me())
      return

    Dialog.show
      displayType: 'mod-no-chrome'
      opacity: 0.75
      reactElement: React.createElement CreateBoardComponent,
        defaultOrg: if model.typeName == 'Organization' then model
        trackingOpts: { category: 'home', method: 'by clicking create new board button in boards tab' }

    track("Boards View", "Clicked 'Create new board' Button")
    return

  getMyBoardsHeader: ->
    React.createElement BoardListSectionHeaderComponent, {
      title: l('board section title.personal boards')
      iconClass: 'member'
    }

  getMyBoards: ->
    _.filter @model.boardList.models, (board) -> !board.isOrgBoard() && board.isOpen()

  getUpgradeButton: (org) ->
    React.createElement UpgradePromptButton, {
      cta: l(['upgrade prompt', 'upgrade'])
      ctaLink: Controller.getOrganizationBillingUrl(org)
      ctaTrackEvent: => trackUe(
        'home',
        'opens',
        'team page bc tab',
        "",
        "",
        "by clicking button upgrade prompt in home page boards tab",
      )
      iconName: IconName.BusinessClass
    }

  getOrgHeader: (org) ->
    linkElements = [
      {
        url: Controller.getOrganizationUrl(org),
        iconClass: 'board',
        titleKey: 'boards',
        onClick: ->
          track 'Boards View', 'Clicked Team Boards Button'
      },
      {
        url: Controller.getOrganizationMembersUrl(org),
        iconClass: 'member',
        titleKey: 'members',
        count: if org.get('memberships') then org.get('memberships').length else null
        onClick: ->
          track 'Boards View', 'Clicked Team Members Button'
      },
      {
        url: Controller.getOrganizationAccountUrl(org),
        iconClass: 'gear',
        titleKey: 'settings',
        onClick: ->
          track 'Boards View', 'Clicked Team Settings Button'
      }
    ]

    if org.belongsToRealEnterprise() and featureFlagClient.get('enterprise.reports', false)
      linkElements.splice(2, 0, {
            url: Controller.getOrganizationReportsUrl(org),
            iconClass: 'home',
            titleKey: 'reports',
            onClick: ->
              track 'Boards View', 'Clicked Team Reports Button'
      })

    linkElementsComponents = linkElements.map(f.choke(1, React, 'createElement', BoardListSectionHeaderLinkComponent))

    if !org.isPremium() && !dontUpsell
      linkElementsComponents.push(@getUpgradeButton(org))

    props =
      title: org.get('displayName')
      iconClass: 'organization'
      logoHash: org.get('logoHash')
      linkElements: linkElementsComponents

    if org.isFeatureEnabled('enterpriseUI')
      props.smallIconClass = 'enterprise'
      props.smallIconTitleKey = 'enterprise'
    else if org.isPremium()
      props.smallIconClass = 'business-class'
      props.smallIconTitleKey = 'business-class'

    React.createElement BoardListSectionHeaderComponent, props

  getOrgBoards: (org) ->
    _.filter @model.boardList.models, (board) =>
      board.getOrganization()?.id == org.id &&
      board.isOpen()

  getNonMemberOrgBoards: (org) ->
    # gets all org boards that current user isn't a part of
    userOrgBoardIds = @getOrgBoards(org).map((board) => board.get('id'))

    _.chain org.boardList.models
    .filter (board) => board.isOpen()
    .map (board) => board.get('id')
    .difference userOrgBoardIds
    .map (boardId) => ModelCache.get('Board', boardId)
    .value()

  getStarredBoardsHeader: ->
    React.createElement BoardListSectionHeaderComponent, {
      title: l('board section title.starred boards')
      iconClass: 'star'
    }

  getStarredTeamBoardsHeader: ->
    React.createElement BoardListSectionHeaderComponent, {
      title: l('board section title.starred team boards')
      iconClass: 'star'
    }

  getStarredBoards: ->
    _.filter @model.boardStarList.getBoards(), (board) ->
      board.isOpen()

  getStarredOrgBoards: (org) ->
    _.filter @model.boardStarList.getBoards(), (board) ->
      board.getOrganization()?.id == org.id &&
      board.isOpen()

  getRecentBoardsHeader: ->
    React.createElement BoardListSectionHeaderComponent, {
      title: l('home board section title.recent')
      iconClass: 'clock'
    }

  getRecentBoards: ->
    recentBoardsHelper.getBoards(@model, @renderReactSection.bind(@)).slice(0, 4)

  getUserTeamBoardsHeader: ->
    React.createElement BoardListSectionHeaderComponent, {
      title: l('board section title.your team boards')
      iconClass: 'member'
    }

  getTeamBoardsHeader: ->
    React.createElement BoardListSectionHeaderComponent, {
      title: l('board section title.team boards')
      iconClass: 'organization'
    }

  remove: ->
    ReactDOM.unmountComponentAtNode(@$reactRoot[0])
    super

  getTeamBoardLinkBanner: (org, emptyStateBanner) ->
    props=
      teamName: org.get('displayName')
      teamBoardsLink: Controller.getMemberOrgUrl(org.get('name'), true)
      emptyStateBanner: emptyStateBanner
      orgId: org.id
      children: ({ banner }) => banner

    React.createElement TeamBoardsLinkBanner, props
